<script>
import {useRoute} from "vue-router";
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";

export default {
  name: "ShowAll",
  components: {LoadingPage},
  setup() {

    let type = ref(useRoute().params.type)
    let products = ref([])

    let loading = ref(false)

    function load_data() {

      loading.value = true
      FreeWorld.Heisenberg({}, 'homepage', true).then((res) => {

        loading.value = false
        products.value = res.data[type.value]

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, load_data)
      })

    }
    load_data()

    return {
      products,
      type,
      loading,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div :class="loading ? 'activeClass':'' " id="main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p v-if="type === 'best_shops'" class="font-color font-4 font-bold">برترین فروشندگان</p>
        <p v-if="type === 'best_selling'" class="font-color font-4 font-bold">پرفروش ترین محصولات</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div v-if="products.length > 0" class="p-body">

      <div v-if="type === 'best_shops'" class="">
        <router-link :to="{name:'DetailsProducts',params:{pid:item.products.id}}" v-for="item in products"
                     :key="item.id"
                     class="animate__animated animate__fadeInRight text-decoration-none bg-white mb-3 shadow-custom p-2 rounded-4 d-flex justify-content-between">
          <div class="w-60 ml-3 d-flex flex-column justify-content-around">
            <div class="overflow-hidden">
              <p class="font-bold font-4" :class="{'txtoverflow': item.products.name.length > 30}">{{
                  item.products.name
                }}</p>
            </div>

            <div class="overflow-hidden">
              <p class="font-5 my-2" :class="{'txtoverflow': item.products.brand.length > 20}">از برند
                {{ item.products.brand }}</p>
            </div>

            <div v-if="item.products.shops !== 0" class="d-flex align-items-center">
              <p v-if="item.products.price !== item.products.price_show"
                 class="font-5 d-flex font-color text-decoration-line-through ml-3">
                {{ item.products.price.toLocaleString() }} </p>
              <p class="font-5 d-flex font-color font-bold">{{ item.products.price_show.toLocaleString() }} تومان</p>
            </div>

            <p v-else class="font-4 d-flex font-color-red font-bold">ناموجود</p>

            <div class="div_hr my-2"></div>

            <div class="d-flex align-items-center justify-content-between">

              <div class="d-flex align-items-center">
                <img class="icon_shop ml-2" src="../assets/img/store_color.svg" alt="">
                <p class="font-5">{{ item.products.shops }} فروشگاه</p>
              </div>

              <div class="bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">مشاهده جزییات</div>
            </div>

          </div>

          <div class="img_prod rounded-3 animated-background">
            <img class="w-100 h-100 rounded-3" :src="item.products.pic" alt="">
          </div>
        </router-link>
      </div>

      <div v-if="type === 'best_selling'" class="">
        <router-link :to="{name:'DetailsProducts',params:{pid:item.id}}" v-for="item in products" :key="item.id"
                     class="animate__animated animate__fadeInRight text-decoration-none bg-white mb-3 shadow-custom p-2 rounded-4 d-flex justify-content-between">
          <div class="w-60 ml-3 d-flex flex-column justify-content-around">
            <div class="overflow-hidden">
              <p class="font-bold font-5" :class="{'txtoverflow': item.name.length > 30}">{{ item.name }}</p>
            </div>

            <!--          <div class="overflow-hidden">-->
            <!--            <p class="font-5 my-2" :class="{'txtoverflow': item.brand.length > 20}">از برند {{ item.brand }}</p>-->
            <!--          </div>-->

            <div v-if="item.shops !== 0" class="d-flex align-items-center">
              <p v-if="item.price !== item.price_show"
                 class="font-5 d-flex font-color text-decoration-line-through ml-3">{{
                  item.price.toLocaleString()
                }} </p>
              <p class="font-5 d-flex font-color font-bold">{{ item.price_show.toLocaleString() }} تومان</p>
            </div>

            <p v-else class="font-4 d-flex font-color-red font-bold">ناموجود</p>

            <div class="div_hr my-2"></div>

            <div class="d-flex align-items-center justify-content-between">

              <div class="d-flex align-items-center">
                <img class="icon_shop ml-2" src="../assets/img/store_color.svg" alt="">
                <p class="font-5">{{ item.shops }} فروشگاه</p>
              </div>

              <div class="bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">مشاهده جزییات</div>
            </div>

          </div>

          <div class="img_prod rounded-3 animated-background">
            <img class="w-100 h-100 rounded-3" :src="item.pic" alt="">
          </div>
        </router-link>
      </div>

    </div>

    <div v-else style="height: 40vh" class="d-flex justify-content-center w-100 animate__animated animate__fadeIn">
      <div class="d-flex flex-column align-items-center justify-content-end">
        <img src="../assets/img/product-not-found.png" class="mb-3 w-40" alt="">
        <p class="font-4 font-bold">متاسفانه محصولی در این دسته بندی وجود ندارد!</p>
      </div>
    </div>

  </div>

</template>

<style scoped>

@media (min-width: 900px) {
  .img_prod {
    width: 26% !important;
    height: 12rem !important;
  }
}

.img_prod {
  width: 40%;
  height: 11.3rem;
}

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

.icon_shop {
  width: 15px;
}
</style>